import { TabType } from '../types'

export interface Job {
  id: string
  job_title: string
  description: string
  company: string
  company_logo: string
  location: string
  location_id: number
  posted_at: string
  url: string
  feed_name: string
  external_slug_id: string
  expired_at: string
  company_id: number
  status: string
  is_easy_apply?: boolean
  group?: number
}

export enum JobEmploymentType {
  FULL_TIME = 'full_time',
  PART_TIME = 'part_time',
  CONTRACT = 'contract',
  TEMPORARY = 'temporary',
  FREELANCER = 'freelancer',
  GIG = 'gig',
  FULL_TIME_PART_TIME = 'full_part_time',
}

export enum JobLocationType {
  REMOTE = 'remote',
  ONSITE = 'onsite',
  HYBRID = 'hybrid',
}

export interface ClusteredJob extends Job {
  relatedJobs: Job[]
}

export interface ResultStats {
  page: number
  page_size: number
  total_jobs: number
  total_pages: number
  location_from_resume?: boolean
  target_role_from_resume?: boolean
}

export interface RecommendJobsApiResponse extends ResultStats {
  jobs: Job[]
}
export interface SearchApiResponse extends RecommendJobsApiResponse {
  corrected_term: string | null
}

export interface PrefillApiResponse {
  jobTitle?: string
  location: {
    country?: string
    region?: string
    city?: string
  }
}

export interface SearchQuery {
  query?: string | null
  location?: string | null
  location_id?: string | null
  location_latitude?: string | null
  location_longitude?: string | null
  page?: string | null
  within_n_days?: string | null
  only_remote_jobs?: boolean
  only_auto_apply_jobs?: boolean
  add_groups?: boolean
  radius?: string | null
  sort_by_coordinates?: boolean
  view?: TabType
  correct_term?: boolean
  external_slug_id?: string | null
  job_location_type?: string | null
  job_type?: string | null
}
